import { render, staticRenderFns } from "./questionbank.vue?vue&type=template&id=b4c57774&scoped=true"
import script from "./questionbank.vue?vue&type=script&lang=js"
export * from "./questionbank.vue?vue&type=script&lang=js"
import style0 from "./questionbank.vue?vue&type=style&index=0&id=b4c57774&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c57774",
  null
  
)

export default component.exports